import styles from '../theme.scss';
const {
    breakpointsXs: breakpointsXsString,
    breakpointsSm: breakpointsSmString,
    breakpointsMd: breakpointsMdString,
    breakpointsLg: breakpointsLgString,
    breakpointsXl: breakpointsXlString,
    transitionsDurationShortest: transitionsDurationShortestString,
    transitionsDurationShorter: transitionsDurationShorterString,
    transitionsDurationShort: transitionsDurationShortString,
    transitionsDurationStandard: transitionsDurationStandardString,
    transitionsDurationComplex: transitionsDurationComplexString,
    transitionsDurationEnteringScreen: transitionsDurationEnteringScreenString,
    transitionsDurationLeavingScreen: transitionsDurationLeavingScreenString,
} = styles;

const breakpointsXs = parseInt(breakpointsXsString, 10);
const breakpointsSm = parseInt(breakpointsSmString, 10);
const breakpointsMd = parseInt(breakpointsMdString, 10);
const breakpointsLg = parseInt(breakpointsLgString, 10);
const breakpointsXl = parseInt(breakpointsXlString, 10);

const transitionsDurationShortest = parseInt(transitionsDurationShortestString, 10);
const transitionsDurationShorter = parseInt(transitionsDurationShorterString, 10);
const transitionsDurationShort = parseInt(transitionsDurationShortString, 10);
const transitionsDurationStandard = parseInt(transitionsDurationStandardString, 10);
const transitionsDurationComplex = parseInt(transitionsDurationComplexString, 10);
const transitionsDurationEnteringScreen = parseInt(transitionsDurationEnteringScreenString, 10);
const transitionsDurationLeavingScreen = parseInt(transitionsDurationLeavingScreenString, 10);

const baseSize = 8;
const spacing = (n) => n * baseSize;

const breakpointsValue = 'px';
const breakpointsKeys = ['xs', 'sm', 'md', 'lg', 'xl'];
const breakpointsStep = 5; // (.05px) The increment used to implement exclusive breakpoints
const breakpointsMap = {
    xs: breakpointsXs,
    sm: breakpointsSm,
    md: breakpointsMd,
    lg: breakpointsLg,
    xl: breakpointsXl,
};

const breakpointsUp = (breakpoint) => {
    if (!Object.prototype.hasOwnProperty.call(breakpointsMap, breakpoint)) {
        throw new Error('Argument breakpoint to function breakpointsUp must be a valid breakpoint');
    }

    const value = breakpointsMap[breakpoint];

    return `(min-width: ${value}${breakpointsValue})`;
};

const breakpointsDown = (breakpoint) => {
    if (!Object.prototype.hasOwnProperty.call(breakpointsMap, breakpoint)) {
        throw new Error('Argument breakpoint to function breakpointsUp must be a valid breakpoint');
    }

    if (breakpoint === 'xl') {
        return breakpointsUp('xs');
    }

    let endIndex = breakpointsKeys.indexOf(breakpoint) + 1;
    const upperbound = breakpointsKeys[endIndex];
    const upperValue = breakpointsMap[upperbound];

    return `(max-width: ${upperValue - breakpointsStep / 100}${breakpointsValue})`;
};

const theme = {
    breakpoints: {
        xs: breakpointsXs,
        sm: breakpointsSm,
        md: breakpointsMd,
        lg: breakpointsLg,
        xl: breakpointsXl,
    },
    breakpointsUp,
    breakpointsDown,
    transitions: {
        durations: {
            shortest: transitionsDurationShortest,
            shorter: transitionsDurationShorter,
            short: transitionsDurationShort,
            standard: transitionsDurationStandard,
            complex: transitionsDurationComplex,
            enteringScreen: transitionsDurationEnteringScreen,
            leavingScreen: transitionsDurationLeavingScreen,
        },
    },
    spacing,
};

export default theme;
